<template>
  <Head>
    <title>{{ entry.seo.title }}</title>
    <meta property="description" :content="entry.seo.description" />
  </Head>

  <Layout :alerts="entry.alerts">
    <PageIntro :data="entry.pageMasthead"></PageIntro>

    <CardGrid :data="entry.pageComponents.ctaCardGroup[1]" />

    <Video
      :videoId="entry.pageComponents.video[0].vimeoNumber"
      :title="entry.pageComponents.video[0].title">
      <span v-html="entry.pageComponents.video[0].description"></span>
    </Video>

    <SectionTextWithImg :data="entry.pageComponents.sectionText[0]" />

    <Cta :data="entry.pageComponents.ctaBanner[0]"> </Cta>

    <CardGrid :data="entry.pageComponents.ctaCardGroup[2]" />

    <TextImageList :data="entry.pageComponents.sectionTextWithImageList[0]" />

    <Cta :data="entry.pageComponents.ctaBanner[1]"> </Cta>

    <CardGrid :data="entry.pageComponents.ctaCardGroup[0]"></CardGrid>

    <Footnotes :footnotes="entry.pageComponents.footnotes[0].footnotes" />
  </Layout>
</template>

<script>
import CardGrid from "../../Components/Page-Components/CardGrid.vue";
import Cta from "../../Components/Page-Components/Cta.vue";
import Footnotes from "../../Components/Atoms/Footnotes.vue";
import SectionTextWithImg from "../../Components/Page-Components/SectionTextWithImg.vue";
import TextImageList from "../../Components/Page-Components/TextImageList.vue";
import Video from "../../Components/Page-Components/Video.vue";

export default {
  components: {
    CardGrid,
    Cta,
    Footnotes,
    SectionTextWithImg,
    TextImageList,
    Video,
  },

  props: {
    siteUrl: String,
    entry: Object,
  },
};
</script>
